import { render, staticRenderFns } from "./ReportInsurance.vue?vue&type=template&id=7c1bfeaa"
import script from "./ReportInsurance.vue?vue&type=script&lang=ts"
export * from "./ReportInsurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports